var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 text-center"},[_c('h3',{staticStyle:{"margin-top":"10px"}},[_c('b',[_vm._v("Movimiento Familiar Cristiano")])]),_c('p',{staticStyle:{"font-size":"1.1rem"}},[_vm._v(" \""),_c('b',[_vm._v("Con Jesús, José y María")]),_vm._v(", misioneros de la familia cada día\" ")])])])
}]

export { render, staticRenderFns }